import { useEffect, useState } from 'react'

import { useApi, useNotification, useUserData } from '../../../../hooks'
import { isStaffUser } from '../../../../utils/user'
import { getWidgetListConfiguration } from '../../Widget.api'

import { resolveWidgetListOrder } from './useWidgetListOrder.utils'

export function useWidgetListOrder({ defaultOrder, page }) {
  const currentUser = useUserData()
  const isStaff = isStaffUser(currentUser)
  const api = useApi()
  const { handleAddErrorNotification } = useNotification()

  const [widgetListOrder, setWidgetListOrder] = useState(defaultOrder)
  const [isOrderResolved, setOrderResolved] = useState(!isStaff)

  useEffect(() => {
    if (isStaff) {
      api
        .call(getWidgetListConfiguration, { page })
        .then(({ data }) => {
          const resolvedOrder = resolveWidgetListOrder(
            data?.widgets?.map(widget => widget.name),
            defaultOrder
          )

          setWidgetListOrder(resolvedOrder)
        })
        .catch(() => {
          handleAddErrorNotification('Error.CommonApiRequestFailKey')
        })
        .finally(() => {
          setOrderResolved(true)
        })
    }
  }, [])

  return { isOrderResolved, widgetListOrder }
}
